let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("j22Hz")).then(() => parcelRequire('1K9Qx'));